import TablaAdminLogsRow from "./rows/TablaAdminLogsRow";
import AdminCard from "../cards/AdminCard";
import { ADMIN_LOGS_FIELDS } from "../../../utils/configs/adminCardConfigs";

function TablaAdminLogs({ items }) {
  if (!items || items.length === 0) {
    return (
      <div className="note info">
        <b>No admin logs found</b>
      </div>
    );
  }

  return (
    <div className="table-wrapper">
      <table className="table admin-logs-table">
        <thead>
          <tr>
            <th className="col-action">Action</th>
            <th className="col-decision">Decision</th>
            <th className="col-actor">Actor</th>
            <th className="col-target">Target</th>
            <th className="col-comment">Comment</th>
            <th className="col-date">Date</th>
          </tr>
        </thead>
        <tbody>
          {items.map((log) => (
            <TablaAdminLogsRow key={log.id} log={log} />
          ))}
        </tbody>
      </table>

      {/* Mobile-friendly cards */}
      <div className="admin-logs-cards">
        {items.map((log) => (
          <AdminCard key={log.id} data={log} fields={ADMIN_LOGS_FIELDS} />
        ))}
      </div>
    </div>
  );
}

export default TablaAdminLogs;
